/**
 * HR hub tab definitions — single source for nav labels, paths, and active matching.
 */
export const HR_BASE = '/portal/hr';

export const HR_TABS = [
  { id: 'all', label: 'All', path: 'all', emoji: '📋' },
  { id: 'materials', label: 'Materials', path: 'materials', emoji: '📂' },
  { id: 'hiring', label: 'Hiring', path: 'hiring', emoji: '🤝' },
  { id: 'direction', label: 'Mission Vision Values', path: 'company-direction', emoji: '🧭' },
];

/** Tabs shown in the HR hub nav (hiddenInNav routes remain reachable by URL). */
export const HR_NAV_TABS = HR_TABS.filter((tab) => !tab.hiddenInNav);

export const DEFAULT_HR_TAB = 'all';

/**
 * Resolve which tab is active from the current pathname.
 * @param {string} pathname - e.g. /portal/hr/materials
 */
export function getActiveHRTabId(pathname) {
  if (!pathname?.startsWith(HR_BASE)) {
    return DEFAULT_HR_TAB;
  }

  const remainder = pathname.slice(HR_BASE.length).replace(/^\//, '');
  if (!remainder) {
    return DEFAULT_HR_TAB;
  }

  const firstSegment = remainder.split('/')[0];

  for (const tab of HR_TABS) {
    const paths = tab.matchPaths || [tab.path];
    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) {
      return tab.id;
    }
  }

  return DEFAULT_HR_TAB;
}

export function getHRTabHref(tab) {
  if (tab.path === '' || tab.id === 'all') {
    return `${HR_BASE}/all`;
  }
  return `${HR_BASE}/${tab.path}`;
}
